/**
 * CookieInventory Service Layer
 * Rule: Business logic, validation, and API orchestration
 * Rule: NO UI IN SDK
 */
import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class CookieInventoryService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return {
                success: true,
                data: response.data,
                pagination: response.pagination || {},
                uniqueValues: response.uniqueValues,
                meta: response.meta || {},
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch cookie-inventory list');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch cookie-inventory');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to create cookie-inventory');
        }
    }

    async update(id, data) {
        try {
            const response = await this.api.update(id, data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to update cookie-inventory');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete cookie-inventory');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
